import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';
import { BodyBoldS, BodyRegularS, HeadingExtraBoldS } from '../../../styles/globals';

export const OverviewCont = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 0;
`;

export const ChartsRow = styled.div`
  display: flex;
  gap: 20px;
  align-items: stretch;
`;

export const Card = styled.div`
  background: ${({ theme }: IThemeProvider) => theme.colors.neutral.primary[0]};
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
`;

export const DonutCard = styled(Card)`
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
`;

export const LegendCard = styled(Card)`
  flex: 1;
  justify-content: center;
  gap: 20px;
`;

export const TimelineCard = styled(Card)`
  flex: 1;
`;

export const CardTitle = styled(BodyBoldS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[60]};
    letter-spacing: 0.04em;
    text-transform: uppercase;
    font-size: 14px;
    margin-bottom: 20px;
  `}
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

interface IDot {
  color: string;
}

export const LegendDot = styled.span<IDot>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ color }: IDot) => color};
`;

export const LegendTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const LegendStatLine = styled(HeadingExtraBoldS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.secondary[100]};
    font-size: 18px;
    line-height: 22px;
  `}
`;

export const LegendName = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[60]};
    font-size: 13px;
  `}
`;

export const SpinnerCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
`;
